import Highcharts from 'highcharts/highcharts'
import HighchartsReact from 'highcharts-react-official'
import { LineBarInterface } from '../ImportBackend/Interfaces/HighChartsInterfaces'

interface PropsInterface {
  titulo: string
  subtitulo: string
  tituloY: string
  tipo: 'column' | 'bar' | 'line'
  propriedades: LineBarInterface
  fnFormatarToolTip?: ( this: Highcharts.Point ) => string
  fnFormatter?: ( this: Highcharts.PointLabelObject ) => string
}

const defaultFnFormatarToolTip = function ( this: Highcharts.Point ) { return this.y ? this.y.toString() : '' }
const defaultFnFormatter = function ( this: Highcharts.PointLabelObject ) { return this.y?.toString() || '' }

export default function Chart ( { titulo, subtitulo, tituloY, propriedades, tipo, fnFormatarToolTip = defaultFnFormatarToolTip, fnFormatter = defaultFnFormatter }: PropsInterface ) {

  const options: Highcharts.Options = {
    chart: {
      type: tipo
    },
    title: {
      text: titulo
    },
    subtitle: {
      text: subtitulo
    },
    yAxis: {
      min: 0,
      title: {
        text: tituloY
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.15,
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          formatter: fnFormatter
        }
      },
      line: {
        dataLabels: {
          enabled: true,
          formatter: fnFormatter
        }
      },
    },
    tooltip: {
      pointFormatter: fnFormatarToolTip
    },
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    exporting: {
      enabled: true,
      pdfFont: {
        normal: 'https://www.highcharts.com/samples/data/fonts/NotoSans-Regular.ttf',
        bold: 'https://www.highcharts.com/samples/data/fonts/NotoSans-Bold.ttf',
        bolditalic: 'https://www.highcharts.com/samples/data/fonts/NotoSans-BoldItalic.ttf',
        italic: 'https://www.highcharts.com/samples/data/fonts/NotoSans-Italic.ttf'
      },
      buttons: {
        contextButton: {
          menuItems: [
            'viewFullscreen',
            'printChart',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadSVG',
            'downloadPDF'
          ]
        }
      }
    }
  }

  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        options={{ ...options, ...propriedades }}
      />
    </>
  )

}